(function ($) {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        var
            // ----------------------------------------------------------
            // VARIABLES ------------------------------------------------
            // ----------------------------------------------------------
            elTrailerPlayer     = document.getElementById('trailer-video'),
            elTrailerTopBtn     = document.getElementById('trailer-top-btn'),
            elCloseTrailerTopBtn= document.getElementById('close-trailer-top-btn'),
            elImgBg             = document.getElementsByClassName('bg-background-profil')[0],
            elShadowBg          = document.getElementsByClassName('has-shadow')[0],
            elTopTrailerBlock   = document.getElementsByClassName('top-trailer')[0],
            topTrailerModal     = document.getElementById('top-trailer-modal'),
            trailerVideoModal   = document.getElementById('trailer-video-modal'),
            overlay             = document.getElementById('top-trailer-overlay'),
            closeBtnVideoModal  = document.getElementById('close-trailer-top-btn-modal'),
            elPosterHiddenIput  = document.getElementsByClassName('posterHiddenInput')[0],
            getImgBgHeightInit  = elImgBg ? parseInt(elImgBg.offsetHeight):0,
            getImgBgHeightNew   = 800,

            // ----------------------------------------------------------
            // FUNCTIONS ------------------------------------------------
            // ----------------------------------------------------------
            showTrailer = function( event) {
                event.preventDefault();
                elTrailerTopBtn.style.visibility = 'hidden';

                // 01. DETECT :  NATIVE MOBILE PLAYER or VIDEOJS PLAYER
                if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                    // DESKTOP
                        elImgBg.style.height    = getImgBgHeightNew+'px';
                        elImgBg.style.opacity   = 0;
                        elShadowBg.style.height = getImgBgHeightNew+'px';
                        // Show Video player block
                        setTimeout( function() {
                            elTopTrailerBlock.style.display = 'block';
                            // PLAY Video player
                            videojs('trailer-video').play();
                        }, 1000);
                }
                // 02. TABLETS/MOBILES
                else {
                    // CREATE Video player tags
                    var source  = document.createElement('source');
                    source.src  = elTrailerTopBtn.getAttribute('href');
                    source.type = 'video/mp4';
                    var video   = document.createElement('video');
                    video.setAttribute('id', 'trailer-video-modal');
                    video.setAttribute('class', 'video-js vjs-default-skin vjs-tech trailer-video vjs-big-play-centered vjs-controls-enabled vjs-has-started');
                    video.setAttribute('width', '100%');
                    video.style.width = "100%";
                    video.setAttribute('height', '100%');
					video.style.height = "100%";
					video.setAttribute('controls', 'controls');
                    video.setAttribute('autoplay', 'autoplay');
                    video.setAttribute('preload', 'auto');
                    if( elPosterHiddenIput) {
                        video.setAttribute('poster', elPosterHiddenIput.getAttribute('value'));
                    }
                    video.setAttribute('data-setup', '{}');
                    topTrailerModal.appendChild(video);
                    topTrailerModal.querySelector('#trailer-video-modal').appendChild(source);
                    // Show Videojs player block
                    topTrailerModal.style.display   = 'block';
                    overlay.style.display           = 'block';
                }
            },
            hideTrailer = function( event) {
                event.preventDefault();
                elTrailerTopBtn.style.visibility = 'visible';

                // DESKTOP
                if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                    // STOP Video player
                    videojs('trailer-video').pause();
                    elTrailerPlayer.src = '';
                    elTrailerPlayer.src = elTrailerTopBtn.getAttribute('href');
                    // HIDE Videojs player block
                    elTopTrailerBlock.style.display = 'none';
                    // ADD styles
                    elImgBg.style.height    = getImgBgHeightInit + 'px';
                    elImgBg.style.opacity   = 1;
                    elShadowBg.style.height = getImgBgHeightInit + 'px';
                }
            },
            hideTrailerModal = function( event) {
                event.preventDefault();
                elTrailerTopBtn.style.visibility = 'visible';
                // TABLETS/MOBILES
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                    // HIDE Videojs player block
                    topTrailerModal.style.display   = 'none';
                    overlay.style.display           = 'none';
                    // STOP Video player
                    var trailerVideoModal = document.getElementById('trailer-video-modal');
                    trailerVideoModal.pause();
                    trailerVideoModal.querySelector('source').src = '';
                    trailerVideoModal.load();
                    // DELETE Video player tags
                    trailerVideoModal.parentNode.removeChild(trailerVideoModal);
                }
            }
            ;

        // ----------------------------------------------------------------
        // APPLY FUNCTIONS ------------------------------------------------
        // ----------------------------------------------------------------
        // SHOW top trailer (block + modal)
        if( elTrailerTopBtn && elTopTrailerBlock && topTrailerModal) {
            elTrailerTopBtn.addEventListener( 'click', showTrailer);
        }
        // HIDE top trailer block
        if( elCloseTrailerTopBtn && elTopTrailerBlock) {
            elCloseTrailerTopBtn.addEventListener( 'click', hideTrailer);
        }
        // HIDE top trailer modal
        if( closeBtnVideoModal && topTrailerModal) {
            closeBtnVideoModal.addEventListener( 'click', hideTrailerModal);
        }
        // VIDEOjs player
        if (elTrailerPlayer) {
            videojs( elTrailerPlayer, {}, function() {});
        }
    });

})(jQuery);
